import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getAdminIsAuth, getCurrentAdmin } from "~/admins/api";

export const authQueryOptionsFactory = createQueryKeys("auth", {
  isAuth: {
    queryKey: null,
    queryFn: () => getAdminIsAuth(),
  },
  currentAdmin: {
    queryKey: null,
    queryFn: () => getCurrentAdmin(),
  },
});
